<template>
  <div class="row despesas">
    <public-header :title="'Despesa Resumida'">
      <div class="row">
        <ano-base />
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <p>
            Aqui você encontra um resumo das despesas realizadas pela Prefeitura
            Municipal de Santos.
          </p>
          <p>
            A Prefeitura Municipal de Santos, no ano de
            <span class="destaque-header">{{ anoAtual }}</span
            >, fez uma previsão de despesas no valor de
            <span class="destaque-header">{{ despesaAnualPrevista.atual }}</span
            >.
          </p>
          <p>
            Deste total, até o mês de
            <span class="destaque-header">{{ mes_base.nome }}</span
            >,
            <span class="destaque-header">{{
              despesaAnualEmpenhada.atual
            }}</span>
            foram empenhados¹,
            <span class="destaque-header">{{
              despesaAnualLiquidada.atual
            }}</span>
            foram liquidados² e
            <span class="destaque-header">{{ despesaAnualPaga.atual }}</span>
            foram pagos³.
          </p>
          <p>
            <span class="destaque-header">1 - Empenho:</span> é efetuada uma
            reserva de dinheiro para pagamento de uma determinada dívida,
            baseada no orçamento previsto. <br />
            <span class="destaque-header">2 - Liquidação:</span> processo de
            ateste de que o serviço foi executado ou o material entregue e que,
            estando tudo certo, pode-se efetuar o pagamento.<br />
            <span class="destaque-header">3 - Pagamento:</span> efetivação do
            pagamento da compra.
          </p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <line-chart
            ref="despesas-linha"
            :chart-data="graficoDespesaLinha"
            :gradiente="false"
            :options="graficoOptions"
          ></line-chart>
        </div>
      </div>
    </public-header>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li><router-link :to="'/'">Início</router-link></li>
          <li>
            <router-link :to="'/receitas_despesas'"
              >Receitas e Despesas</router-link
            >
          </li>
          <li class="">Despesas</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h2>Previsão de Gastos</h2>
        </div>
        <div class="col-xs-12">
          <div class="btn-group btn-group-toggle margem-bottom">
            <label class="btn btn-primary">
              <input
                type="radio"
                name="options"
                value="ue"
                id="option1"
                v-model="tipo_operacao"
                checked
              />
              Unidade Executora
            </label>
            <label class="btn btn-primary">
              <input
                type="radio"
                name="options"
                value="fs"
                id="option2"
                v-model="tipo_operacao"
              />
              Função e Subfunção
            </label>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div class="row">
          <div
            v-for="item in listaCards"
            :key="item.nome"
            class="col-sm-6 col-md-4 card-base"
          >
            <router-link
              :to="{
                name: 'detalhe_grupo_despesa',
                params: { descricao: item.chave, operacao: tipo_operacao }
              }"
            >
              <div
                class="card-despesa bg"
                :style="{
                  backgroundImage:
                    'url(' + require(`@/assets/css/img/${item.ico}`) + ')'
                }"
              >
                <div class="context">
                  <h3 class="small">{{ item.nome }}</h3>
                  <span>{{ item.vl_previsto }}</span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  PublicHeader,
  LineChart2 as LineChart,
  AnoBase
} from '@/components/common/'
import Doughnut from '@/components/common/DoughnutChart'
import colors from '@/utils/colors.js'
import Card from '../Card'
import { mapState } from 'vuex'

export default {
  name: 'despesas',
  components: { PublicHeader, Doughnut, LineChart, Card, AnoBase },
  data() {
    return {
      tipo_operacao: 'ue',
      graficos_base: {
        labels: [],
        datasets: [{ label: '', backgroundColor: [], data: [] }]
      },
      graficoOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Previsão de Gastos / Empenho / Liquidação / Pagamento',
          fontColor: '#C1D1C1'
        },
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMax: 50,
                fontColor: '#C1D1C1',
                callback: function(value, index, values) {
                  return value.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                }
              }
            }
          ],
          xAxes: [
            {
              maxBarThickness: 50,
              ticks: {
                fontColor: '#C1D1C1'
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label
              var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })
              return xLabel + ': ' + yLabel
            }
          }
        }
      },
      secretaria: [
        {
          original: '01.10 - EXECUTIVO',
          resumido: 'EXECUTIVO',
          img: 'ico-servidor.svg'
        },
        {
          original: '01.12 - SECRETARIA DE FINANCAS',
          resumido: 'FINANÇAS',
          img: 'ico-financas.svg'
        },
        {
          original: '01.13 - SECRETARIA DE GESTAO',
          resumido: 'GESTÃO',
          img: 'ico-gestao.svg'
        },
        {
          original: '01.14 - SECRETARIA DE EDUCAÇÃO',
          resumido: 'EDUCAÇÃO',
          img: 'ico-educacao.svg'
        },
        {
          original: '01.15 - SECRETARIA DE SAÚDE',
          resumido: 'SAÚDE',
          img: 'ico-saude.svg'
        },
        {
          original: '01.17 - SECRETARIA DE INFRAESTRUTURA E EDIFIC',
          resumido: 'INFRAESTRUTURA',
          img: 'ico-manutencao.svg'
        },
        {
          original: '01.18 - SECRETARIA DE TURISMO',
          resumido: 'TURISMO',
          img: 'ico-turismo.svg'
        },
        {
          original:
            '01.18 - SECRETARIA DE EMPREENDEDORISMO, ECONOMIA CRIATIVA E TURISMO',
          resumido: 'EMPREENDEDORISMO E TURISMO',
          img: 'ico-turismo.svg'
        },
        {
          original: '01.19 - SECRETARIA DE ESPORTES',
          resumido: 'ESPORTES',
          img: 'ico-esporte.svg'
        },
        {
          original: '01.20 - SECRETARIA DE CULTURA',
          resumido: 'CULTURA',
          img: 'ico-cultura.svg'
        },
        {
          original: '01.21 - SECRETARIA DE DESENVOLVIMENTO URBANO',
          resumido: 'DESENVOLVIMENTO URBANO',
          img: 'ico-urbanismo.svg'
        },
        {
          original: '01.23 - SECRETARIA DE MEIO AMBIENTE',
          resumido: 'MEIO AMBIENTE',
          img: 'ico-meioambiente.svg'
        },
        {
          original: '01.24 - PROCURADORIA GERAL DO MUNICIPIO',
          resumido: 'PROCURADORIA',
          img: 'ico-servidor.svg'
        },
        {
          original: '01.27 - SECRETARIA DE SEGURANÇA',
          resumido: 'SEGURANÇA',
          img: 'ico-seguranca.svg'
        },
        {
          original: '01.29 - SECRETARIA DE SERVICOS PUBLICOS',
          resumido: 'SERVIÇOS PÚBLICOS',
          img: 'ico-servico-servicospublicos.svg'
        },
        {
          original: '01.35 - SECRETARIA MUNICIPAL DE GOVERNO',
          resumido: 'GOVERNO',
          img: 'ico-governo.svg'
        },
        {
          original: '01.37 - OUVIDORIA, TRANSPARENCIA E CONTROLE',
          resumido: 'OUVIDORIA',
          img: 'ico-ouvidoria.svg'
        },
        {
          original:
            '01.39 - SECRETARIA MUN. DE ASSUNTOS PORTUÁRIOS, INDÚSTRIA E COMÉRCIO',
          resumido: 'PORTO, INDÚSTRIA E COMÉRCIO',
          img: 'ico-porto.svg'
        },
        {
          original:
            '01.39 - SECRETARIA MUN. DE ASSUNTOS PORTUÁRIOS E PROJETOS ESPECIAIS',
          resumido: 'PORTO E PROJETOS ESPECIAIS',
          img: 'ico-porto.svg'
        },
        {
          original: '01.40 - SECRETARIA MUNICIPAL DE DESENVOLVIMENTO SOCIAL',
          resumido: 'DESENVOLVIMENTO SOCIAL',
          img: 'ico-assistencia.svg'
        },
        {
          original:
            '01.41 - SECRETARIA DE COMUNICAÇÃO SOCIAL E RELAÇÕES INSTITUCIONAIS',
          resumido: 'COMUNICAÇÃO SOCIAL',
          img: 'ico-comunicacao.svg'
        },
        {
          original: '01.42 - SECRETARIA MUNICIPAL DE PLANEJAMENTO E INOVAÇÃO',
          resumido: 'PLANEJAMENTO',
          img: 'ico-gestao.svg'
        },
        {
          original: '01.49 - ENCARGOS GERAIS DO MUNICÍPIO',
          resumido: 'ENCARGOS GERAIS',
          img: 'ico-financas.svg'
        },
        {
          original: '04 - Administração',
          resumido: 'Administração',
          img: 'ico-servidor.svg'
        },
        {
          original: '06 - Segurança Pública',
          resumido: 'Segurança Pública',
          img: 'ico-seguranca.svg'
        },
        {
          original: '08 - Assistência Social',
          resumido: 'Assistência Social',
          img: 'ico-assistencia.svg'
        },
        { original: '10 - Saúde', resumido: 'Saúde', img: 'ico-saude.svg' },
        {
          original: '12 - Educação',
          resumido: 'Educação',
          img: 'ico-educacao.svg'
        },
        {
          original: '13 - Cultura',
          resumido: 'Cultura',
          img: 'ico-cultura.svg'
        },
        {
          original: '14 - Direitos da Cidadania',
          resumido: 'Direitos da Cidadania',
          img: 'ico-default.svg'
        },
        {
          original: '15 - Urbanismo',
          resumido: 'Urbanismo',
          img: 'ico-urbanismo.svg'
        },
        {
          original: '16 - Habitação',
          resumido: 'Habitação',
          img: 'ico-imovel.svg'
        },
        {
          original: '17 - Saneamento',
          resumido: 'Saneamento',
          img: 'ico-financas.svg'
        },
        {
          original: '18 - Gestão Ambiental',
          resumido: 'Gestão Ambiental',
          img: 'ico-servico-servicospublicos.svg'
        },
        {
          original: '23 - Comércio e Serviços',
          resumido: 'Comércio e Serviços',
          img: 'ico-compras.svg'
        },
        {
          original: '27 - Desporto e Lazer',
          resumido: 'Desporto e Lazer',
          img: 'ico-esporte.svg'
        },
        {
          original: '28 - Encargos especiais',
          resumido: 'Encargos especiais',
          img: 'ico-financas.svg'
        },
        {
          original: '99 - Reserva de Contingência',
          resumido: 'Reserva de Contingência',
          img: 'ico-governo.svg'
        }
      ]
    }
  },
  methods: {
    retornaAtualPorKey(key) {
      const { detalhamento_despesas } = this.$store.state.receitas_despesas

      const reducer = (acumulador, atual) => {
        return acumulador + atual[key]
      }

      let resultAtual = detalhamento_despesas.reduce(reducer, 0)

      return resultAtual
    },
    retornaSomaPorKey(key) {
      const { detalhamento_despesas } = this.$store.state.receitas_despesas

      const reducer = (acumulador, atual) => {
        return acumulador + atual[key]
      }

      let resultAtual = detalhamento_despesas.reduce(reducer, 0)

      return {
        atual: this.formatarMoeda(resultAtual)
      }
    },
    retornaSomaPorNatureza() {
      const { detalhamento_despesas } = this.$store.state.receitas_despesas

      const reducer = (acumulador, atual) => {
        if (atual.natureza in acumulador) {
          acumulador[atual.natureza].vl_previsto += atual.vl_previsto
          acumulador[atual.natureza].vl_total_emp += atual.vl_total_emp
          acumulador[atual.natureza].vl_total_liq += atual.vl_total_liq
          acumulador[atual.natureza].vl_total_pag += atual.vl_total_pag
        } else {
          acumulador[atual.natureza] = {
            vl_previsto: atual.vl_previsto,
            vl_total_emp: atual.vl_total_emp,
            vl_total_liq: atual.vl_total_liq,
            vl_total_pag: atual.vl_total_pag
          }
        }

        return acumulador
      }

      return detalhamento_despesas.reduce(reducer, {})
    },
    formatarMoeda(val) {
      return val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }
  },
  computed: {
    ...mapState({
      anoAtual: state => state.receitas_despesas.ano_base
    }),
    mes_base() {
      const data = new Date()
      if (this.anoAtual !== data.getFullYear()) {
        const val = new Date(this.anoAtual, 11, 31)
        return {
          nome: val.toLocaleString('default', { month: 'long' }),
          valor: val.getMonth()
        }
      }

      return {
        nome: data.toLocaleString('default', { month: 'long' }),
        valor: data.getMonth()
      }
    },
    listaCards() {
      let grupo_despesas = []
      switch (this.tipo_operacao) {
        case 'ue':
          grupo_despesas = [
            ...this.$store.state.receitas_despesas.grupo_despesas
          ]
          break
        case 'fs':
          grupo_despesas = [
            ...this.$store.state.receitas_despesas.funcao_subfuncao
          ]
          break
      }

      const nivelUm = obj => {
        if ('nivel' in obj && obj.nivel === '1') {
          return true
        }

        return false
      }

      const filtrado = grupo_despesas.filter(nivelUm)

      const mapper = obj => {
        const resumido = element => {
          return element.original === obj.descricao
        }

        const item = this.secretaria.find(resumido)

        if (item === undefined) {
          return {
            nome: obj.descricao,
            vl_previsto: this.formatarMoeda(Number(obj.vl_previsto)),
            ico: 'ico-governo.svg',
            descricao: obj.descricao,
            chave: obj.chave
          }
        }

        return {
          nome: item.resumido,
          vl_previsto: this.formatarMoeda(Number(obj.vl_previsto)),
          ico: item.img,
          descricao: obj.descricao,
          chave: obj.chave
        }
      }

      return filtrado.map(mapper)
    },
    despesaAnualPrevista() {
      return this.retornaSomaPorKey('vl_previsto')
    },
    despesaAnualEmpenhada() {
      return this.retornaSomaPorKey('vl_total_emp')
    },
    despesaAnualLiquidada() {
      return this.retornaSomaPorKey('vl_total_liq')
    },
    despesaAnualPaga() {
      return this.retornaSomaPorKey('vl_total_pag')
    },
    graficoDespesaLinha() {
      const dataPrevisto = Array(12).fill(
        this.retornaAtualPorKey('vl_previsto')
      )
      let labels = []
      let dataEmpenhado = [],
        dataLiquidado = [],
        dataPago = []
      let emp = 0,
        liq = 0,
        pag = 0

      for (let index = 0; index <= this.mes_base.valor; index++) {
        labels.push(
          new Date(this.anoAtual, index, 1)
            .toLocaleString('default', { month: 'short' })
            .substr(0, 3)
        )
      }

      for (let index = 0; index < labels.length; index++) {
        const element = labels[index]
        emp += this.retornaAtualPorKey(`vl_${element.toLowerCase()}_emp`)
        liq += this.retornaAtualPorKey(`vl_${element.toLowerCase()}_liq`)
        pag += this.retornaAtualPorKey(`vl_${element.toLowerCase()}_pag`)
        dataEmpenhado.push(emp)
        dataLiquidado.push(liq)
        dataPago.push(pag)
      }

      return {
        ...this.graficos_base,
        labels,
        datasets: [
          {
            data: dataPago,
            label: 'Pago',
            backgroundColor: colors.coresRGB[0]
          },
          {
            data: dataLiquidado,
            label: 'Liquidado',
            backgroundColor: colors.coresRGB[6]
          },
          {
            data: dataEmpenhado,
            label: 'Empenhado',
            backgroundColor: colors.coresRGB[2]
          },
          {
            data: dataPrevisto,
            label: 'Previsão de Gastos',
            backgroundColor: colors.coresRGB[1]
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.card-base {
  margin-bottom: 30px;
}
.card-despesa {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 10px 1px;
}
.card-despesa.bg {
  background-repeat: no-repeat;
  background-size: 80% 80%;
  background-position: center;
  opacity: 0.5;
}
a:hover .card-despesa {
  /* box-shadow: 0 4px 5px 2px #e8e8e8, 0 2px 1px 1px #d8d8d8; */
  transform: translateY(-4px);
}
.card-despesa .context h3 {
  font-size: 1.5em;
}
.card-despesa .context {
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.9);
  font-size: 1.4em;
}
</style>



// WEBPACK FOOTER //
// src/views/public/receitas_despesas/despesas/index.vue